export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : ''
        this.customerRelationId = item != null ? item.customerRelationId : ''
        this.firstName= item != null ? item.firstName : ''
        this.lastName= item != null ? item.lastName : ''
        this.function= item != null ? item.function : ''
        this.landlineNumber = item != null ? item.landlineNumber.number : ''
        this.mobileNumber = item != null ? item.mobileNumber.number : ''
        this.emailAddress = item != null ? item.emailAddress.address : ''
    }
}